/* eslint-disable no-console, no-unused-vars */
import SiteModal from './site-modal';

const modalToggle = () => {
  const btns = document.querySelectorAll('.modal-toggle-btn');
  [].map.call(btns, (toggleBtn) => {
    const id = toggleBtn.getAttribute('data-modal-id');
    const modalDiv = document.getElementById(id);
    if (modalDiv !== null) {
      const modal = new SiteModal({
        id,
        toggleBtn,
      });
    }
  });
};

export default modalToggle;
/* eslint-enable no-console, no-unused-vars */
